import { journeySettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
export class JourneyController {
    static $inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2', 'ApplicationService2', 'AuthenticationService'];
    constructor(LoadingService, TranslateService, application, AccountService2, ApplicationService2, AuthenticationService) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.ApplicationService2 = ApplicationService2;
        this.AuthenticationService = AuthenticationService;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.settingsSource = journeySettingsSource;
    }
    async $onInit() {
        const botAccount = await this.ApplicationService2.getAccount();
        const userAccount = await this.AccountService2.me();
        const userToken = this.AuthenticationService.token;
        const userEmail = encodeURIComponent(userAccount.email);
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.language = this.TranslateService.getCurrentLanguage();
        this.ownerIdentity = useDelegation ? `${userEmail}/${this.application.shortName}` : this.application.shortName;
        this.token = useDelegation ? userToken : this.application.accessKey;
        this.user = userAccount;
        this.botName = this.application.name;
        this.botIdentity = botAccount.identity;
        this.authEmail = this.AuthenticationService.email;
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.LoadingService.stopLoading();
    }
}
JourneyController.$inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2', 'ApplicationService2', 'AuthenticationService'];
